import { CustomError, ICustomErrorProps } from './CustomError';

export interface IApiErrorProps extends ICustomErrorProps {
  /**
   * The error code to log.
   */
  code: string;
  /**
   * A correlation ID that can be used for associating this error with a particular request.
   */
  correlationId?: string;
  /**
   * Whether or not the error is considered expected at the site where it originates.
   * Defaults to `false`.
   */
  isExpected?: boolean;
}

/**
 * Custom error base class for the common scenario of generic errors that should be reported in
 * Quality of Service metrics.
 */
export class ApiError extends CustomError {
  /**
   * The error code to be reported.
   */
  public readonly code?: string;
  /**
   * A correlation ID that can be used for associating this error with a particular request.
   */
  public readonly correlationId?: string;
  /**
   * Whether or not the error was considered expected at the site where it originated.
   */
  public readonly isExpected!: boolean;

  public constructor(props: IApiErrorProps) {
    super(props);

    this.correlationId = props.correlationId;
    this.isExpected = !!props.isExpected;
    this.code = props.code || 'ApiError';
  }
}